import Styles from './TableBorderStylePicker.module.scss'
import cx from 'classnames'
import { type EditorView } from 'prosemirror-view'
import { setBorderAttr } from 'common/Prose/Commands/table/mutation'
import { styleOptions } from 'prose-core'
import { Tooltip } from 'components/Tooltip/Tooltip'

type style = (typeof styleOptions)[number]
type Props = {
  closePicker?: () => void
  includeDropdownStyles?: boolean
  view: EditorView
  focusView?: boolean
}

export const TableBorderStylePicker = ({
  closePicker,
  includeDropdownStyles = true,
  view,
  focusView = true,
}: Props) => {
  const activeStyles: style[] = []

  const setBorderStyle = (style: style) => {
    setBorderAttr({ style })(view.state, view.dispatch)
    closePicker?.()
    if (focusView) view.focus()
  }

  return (
    <div className={cx({ [Styles.dropdownContainer]: includeDropdownStyles })}>
      <div className={Styles.styleOptions}>
        {styleOptions.map((style) => (
          <Tooltip key={style} label={style} placement="right">
            <div
              aria-label={`Change border style to ${style}`}
              className={cx(Styles.styleOption, { [Styles.active]: activeStyles.includes(style) })}
              onClick={() => setBorderStyle(style)}
              role="button"
            >
              <span style={{ borderTopStyle: style }}></span>
            </div>
          </Tooltip>
        ))}
      </div>
    </div>
  )
}
